/**
 * @generated SignedSource<<f6594bb6a911dd95aae2f9769b275821>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserProfileTablePaginationFragment_gwtUsers$data = {
  readonly gwtUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly company: {
          readonly name: string;
          readonly rowId: UUID;
        } | null | undefined;
        readonly createdAt: Date | null | undefined;
        readonly firstName: string;
        readonly jobTitle: string | null | undefined;
        readonly lastName: string;
        readonly programs: ReadonlyArray<ProgramType | null | undefined>;
        readonly rowId: UUID;
        readonly status: UserStatus;
        readonly userPriority: number;
        readonly userType: UserType;
        readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_gwtUser" | "UserOptions_gwtUser" | "UserPriority_gwtUser" | "UserProgramsDisplay">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "UserProfileTablePaginationFragment_gwtUsers";
};
export type UserProfileTablePaginationFragment_gwtUsers$key = {
  readonly " $data"?: UserProfileTablePaginationFragment_gwtUsers$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileTablePaginationFragment_gwtUsers">;
};

import UserProfileTablePaginationQuery_Refetchable_graphql from './UserProfileTablePaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "gwtUsers"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUsersOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": UserProfileTablePaginationQuery_Refetchable_graphql
    }
  },
  "name": "UserProfileTablePaginationFragment_gwtUsers",
  "selections": [
    {
      "alias": "gwtUsers",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "gwtUserFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "gwtUsersOrderBy"
        }
      ],
      "concreteType": "GwtUsersConnection",
      "kind": "LinkedField",
      "name": "__UserProfileTable_gwtUsers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GwtUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GwtUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "programs",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userPriority",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Company",
                  "kind": "LinkedField",
                  "name": "company",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserPriority_gwtUser"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatar_gwtUser"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserOptions_gwtUser"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserProgramsDisplay"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "13f32e8cebb9bfdc796106416264dab6";

export default node;
